import { Component, OnInit } from "@angular/core";
import { PlanChooserService, ProductPlan } from "./plan-chooser.service";

@Component({
    selector: "app-plan-chooser",
    templateUrl: "./plan-chooser.component.html",
    styleUrls: ["./plan-chooser.component.scss"],
    standalone: false
})
export class PlanChooserComponent implements OnInit {
  plans: ProductPlan[];
  constructor(private planChooserService: PlanChooserService) {}

  ngOnInit() {
    this.plans = this.planChooserService.getProductPlans();
  }
}
